import type React from 'react';
import { classNames } from '@/lib/utils';
import type { LoadingSpinnerProps } from './LoadingSpinner.types';

const sizeClasses = {
  sm: 'w-4 h-4 border-2',
  md: 'w-10 h-10 border-4',
  lg: 'w-16 h-16 border-4',
};

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 'md',
  className = '',
  centered = false,
  fullWidth = false,
  wrapperClassName = '',
}) => {
  const spinner = (
    <span
      className={classNames(sizeClasses[size], 'border-white/20 border-t-white rounded-full animate-spin', className)}
      aria-busy="true"
    />
  );

  if (!centered) {
    return spinner;
  }

  return (
    <div className={classNames('flex justify-center items-center', fullWidth && 'w-full', wrapperClassName)}>
      {spinner}
    </div>
  );
};
